export default class ProviderCannotEditError extends Error {
    constructor() {
        super('User information can only be edited by your oAuth provider');
    }
}
